/**
 * Customer API Client
 * Handles all API requests related to customer management
 */

import { client } from "@/lib/hono";

/**
 * Get all customers
 */
export async function getCustomers() {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers.$get();
  if (!response.ok) {
    throw new Error("Failed to fetch customers");
  }
  return await response.json();
}

/**
 * Get a single customer by ID
 */
export async function getCustomer(id: string) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers[":id"].$get({ param: { id } });
  if (!response.ok) {
    throw new Error("Failed to fetch customer");
  }
  return await response.json();
}

/**
 * Create a new customer
 */
export async function createCustomer(data: Record<string, unknown>) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers.$post({ json: data });
  if (!response.ok) {
    throw new Error("Failed to create customer");
  }
  return await response.json();
}
/**
 * Update an existing customer
 */
export async function updateCustomer(id: string, data: Record<string, unknown>) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers[":id"].$patch({
    param: { id },
    json: data,
  });
  if (!response.ok) {
    throw new Error("Failed to update customer");
  }
  return await response.json();
}

/**
 * Delete a customer
 */
export async function deleteCustomer(id: string) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers[":id"].$delete({ param: { id } });
  if (!response.ok) {
    throw new Error("Failed to delete customer");
  }
}

/**
 * Add an email address to a customer
 */
export async function addCustomerEmail(customerId: string, email: string, isPrimary: boolean = false) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers[":id"].emails.$post({
    param: { id: customerId },
    json: {
      email,
      isPrimary: isPrimary ? "true" : "false",
    },
  });
  if (!response.ok) {
    throw new Error("Failed to add email");
  }
  return await response.json();
}

/**
 * Delete a customer email
 */
export async function deleteCustomerEmail(customerId: string, emailId: string) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers[":id"].emails[":emailId"].$delete({
    param: { id: customerId, emailId },
  });
  if (!response.ok) {
    throw new Error("Failed to delete email");
  }
}

/**
 * Preview the next customer number that would be generated
 */
export async function previewCustomerNumber() {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api.customers["preview-number"].$get();
  if (!response.ok) {
    throw new Error("Failed to preview customer number");
  }
  return await response.json();
}
